<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<div class="report-scroll-container">
    <button mat-flat-button (click)="goBack()" class="back-btn xs:!ml-[-3px]  xs:!justify-start top-[2px]">
      <mat-icon class="xs:!ml-[-18px] xs:!text-base xs:!h-[23px] back-icon">arrow_back_ios_new</mat-icon>
      Back
    </button>
    <button mat-stroked-button (click)="openSummary()" class="top-[2px]">
      <mat-icon>description</mat-icon>
      One-page statement
    </button>
    <div class="tables-div" *ngIf="dataAvailable">
        <div>
            <table cellpadding="5px" cellspacing="1" style="width: 100%;">
                <tr style="height: 80px;">
                    <td colspan="17">
                        <img width="50px"
                            src="https://storage.cloud.google.com/menus/static/frontend/img/lab-report-logo.png">
                        <span class="company"><span class="blue">Labrador</span> &nbsp;<span
                                class="grey">AI</span></span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4" class="title revert">Monthly Statement</td>
                </tr>
                <tr>
                    <td colspan="2">Statement Period</td>
                    <td colspan="3" class="border-right">{{data.start_date}} - {{data.end_date}}</td>
                </tr>
                <tr>
                    <td colspan="6">{{data.store.store_name}}</td>
                    <td colspan="4"></td>
                </tr>
                <tr>
                    <td colspan="8">{{data.store.contact_name}}</td>
                    <td colspan="9"></td>
                </tr>
                <tr>
                    <td colspan="8">{{data.store.address}}</td>
                    <td colspan="9"></td>
                </tr>
                <tr>
                    <td colspan="17">&nbsp;</td>
                </tr>
            </table>
        </div>
        <div style="display: flex;flex-direction:column">
            <div style="display:flex">
                <!-- ===== LEFT COLUMN: ALL 9 SECTIONS (mini report data) ===== -->
                <div fxFlex="25% 25%">

                    <!-- 1. SALES -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%;">
                        <tr>
                            <td colspan="8" class="header">SALES</td>
                        </tr>
                        <tr>
                            <td colspan="3">Gross Sales{{ showThirdPartyColumns ? ' (Combined)' : '' }} ({{m.all.total_receipts_count || m.all.total_orders || 0}})</td>
                            <td colspan="5">{{m.all.gross_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Gross Sales ({{m.pos.total_receipts_count || m.pos.total_orders || 0}})</td>
                            <td colspan="5">{{m.pos.gross_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Gross Sales ({{m.online.total_receipts_count || m.online.total_orders || 0}})</td>
                            <td colspan="5">{{m.online.gross_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Gross sales ({{m.kiosk.total_receipts_count || m.kiosk.total_orders || 0}})</td>
                            <td colspan="5">{{m.kiosk.gross_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Third-party apps Gross Sales ({{m.third.total_receipts_count || m.third.total_orders || 0}})</td>
                            <td colspan="5">{{m.third.gross_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Discounts/Promos ({{m.all.discounts_count || 0}})</td>
                            <td colspan="5">{{m.all.discounts || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Discounts/Promos ({{m.pos.discounts_count || 0}})</td>
                            <td colspan="5">{{m.pos.discounts || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Discounts/Promos ({{m.online.discounts_count || 0}})</td>
                            <td colspan="5">{{m.online.discounts || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Discounts/Promos ({{m.kiosk.discounts_count || 0}})</td>
                            <td colspan="5">{{m.kiosk.discounts || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Third-party apps Discounts/Promos ({{m.third.discounts_count || 0}})</td>
                            <td colspan="5">{{m.third.discounts || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Voids/Refunds/Comps ({{m.all.refund_quantity || 0}})</td>
                            <td colspan="5">{{m.all.refund_net_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Voids/Refunds/Comps ({{m.pos.refund_quantity || 0}})</td>
                            <td colspan="5">{{m.pos.refund_net_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Voids/Refunds/Comps ({{m.online.refund_quantity || 0}})</td>
                            <td colspan="5">{{m.online.refund_net_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Voids/Refunds/Comps ({{m.kiosk.refund_quantity || 0}})</td>
                            <td colspan="5">{{m.kiosk.refund_net_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Third-party apps Voids/Refunds/Comps ({{m.third.refund_quantity || 0}})</td>
                            <td colspan="5">{{m.third.refund_net_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Net Sales (Revenue{{ showThirdPartyColumns ? ', Combined' : '' }}) ({{m.all.total_receipts_count || m.all.total_orders || 0}})</td>
                            <td colspan="5">{{m.adjusted.adjNetSales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Net Sales ({{m.pos.total_receipts_count || m.pos.total_orders || 0}})</td>
                            <td colspan="5">{{m.pos.net_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Net Sales ({{m.online.total_receipts_count || m.online.total_orders || 0}})</td>
                            <td colspan="5">{{m.adjusted.adjOnlineNetSales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Net Sales ({{m.kiosk.total_receipts_count || m.kiosk.total_orders || 0}})</td>
                            <td colspan="5">{{m.kiosk.net_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Third-party apps Net Sales ({{m.third.total_receipts_count || m.third.total_orders || 0}})</td>
                            <td colspan="5">{{m.third.net_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3"><b>Taxable Sales</b></td>
                            <td colspan="5">{{m.all.net_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Taxable Sales</td>
                            <td colspan="5">{{m.pos.net_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Taxable Sales</td>
                            <td colspan="5">{{m.online.net_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Taxable Sales</td>
                            <td colspan="5">{{m.kiosk.net_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Cash Taxable Net Sales</td>
                            <td colspan="5">{{m.all.cash_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Credit Taxable Net Sales</td>
                            <td colspan="5">{{m.all.credit_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Non-Taxable Sales</td>
                            <td colspan="5">{{m.all.non_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Non-Taxable Sales</td>
                            <td colspan="5">{{m.pos.non_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Non-Taxable Sales</td>
                            <td colspan="5">{{m.online.non_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Non-Taxable Sales</td>
                            <td colspan="5">{{m.kiosk.non_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Cash Non-Taxable Net Sales</td>
                            <td colspan="5">{{m.all.non_taxable_sale_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Credit Non-Taxable Net Sales</td>
                            <td colspan="5">{{m.all.non_taxable_sale_card || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="17">&nbsp;</td>
                        </tr>
                    </table>

                    <!-- 2. TAXES -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">TAXES</td>
                        </tr>
                        <tr>
                            <td colspan="3">Sales Tax Collected ({{m.all.taxes_count || 0}})</td>
                            <td colspan="5">{{m.adjusted.adjTaxes || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">State Tax collected ({{data.store.state_tax_percent || 0}}%)</td>
                            <td colspan="5">{{m.adjusted.adjStateTax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">In-Store State Sales Tax</td>
                            <td colspan="5">{{m.adjusted.adjInStoreState || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Online State Sales Tax</td>
                            <td colspan="5">{{m.adjusted.adjOnlineState || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Kiosk State Sales Tax</td>
                            <td colspan="5">{{m.kiosk.state_tax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Local Meals Tax ({{data.store.local_tax_percent || 0}}%)</td>
                            <td colspan="5">{{m.adjusted.adjLocalTax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">In-Store Local Meals Tax</td>
                            <td colspan="5">{{m.pos.local_tax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Online Local Meals Tax</td>
                            <td colspan="5">{{m.online.local_tax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Kiosk Local Meals Tax</td>
                            <td colspan="5">{{m.kiosk.local_tax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <!-- Additional taxes (mixed beverage, sugary drink …) — only for stores that have them -->
                        <ng-container *ngIf="+m.all.additional_tax > 0 || m.all.additional_taxes?.length">
                            <tr>
                                <td colspan="3" style="padding-left: 20px;">Additional Taxes</td>
                                <td colspan="5">{{m.all.additional_tax || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr *ngFor="let t of m.all.additional_taxes || []">
                                <td colspan="3" style="padding-left: 32px;">{{t.label || t.name}} ({{t.rate_percent | safeNumber:'1.0-4'}}%)</td>
                                <td colspan="5">{{t.amount || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="padding-left: 32px;">In-Store Additional Taxes</td>
                                <td colspan="5">{{m.pos.additional_tax || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="padding-left: 32px;">Online Additional Taxes</td>
                                <td colspan="5">{{m.online.additional_tax || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="3">Sales Tax Collected based on Payment Type</td>
                            <td colspan="5"></td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Tax collected on CASH</td>
                            <td colspan="5">{{m.adjusted.adjCashTax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">State tax collected on CASH</td>
                            <td colspan="5">{{m.all.state_tax_collected_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Local tax collected on CASH</td>
                            <td colspan="5">{{m.all.local_tax_collected_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Tax collected on CREDIT</td>
                            <td colspan="5">{{m.adjusted.adjCreditTax || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">State tax collected on CREDIT</td>
                            <td colspan="5">{{m.all.state_tax_collected_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Local tax collected on CREDIT</td>
                            <td colspan="5">{{m.all.local_tax_collected_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_third_party > 0">
                            <td colspan="3" style="padding-left: 20px;">Tax collected on THIRD PARTY</td>
                            <td colspan="5">{{m.all.tax_collected_third_party || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_third_party > 0">
                            <td colspan="3" style="padding-left: 32px;">State tax collected on THIRD PARTY</td>
                            <td colspan="5">{{m.all.state_tax_collected_third_party || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_third_party > 0">
                            <td colspan="3" style="padding-left: 32px;">Local tax collected on THIRD PARTY</td>
                            <td colspan="5">{{m.all.local_tax_collected_third_party || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_other > 0">
                            <td colspan="3" style="padding-left: 20px;">Tax collected on OTHER (Gift / Store Credit / Keyed / Pay Later)</td>
                            <td colspan="5">{{m.all.tax_collected_other || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_other > 0">
                            <td colspan="3" style="padding-left: 32px;">State tax collected on OTHER</td>
                            <td colspan="5">{{m.all.state_tax_collected_other || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.all.tax_collected_other > 0">
                            <td colspan="3" style="padding-left: 32px;">Local tax collected on OTHER</td>
                            <td colspan="5">{{m.all.local_tax_collected_other || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 3. GIFT CARDS -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Gift Cards</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Value Gift Cards Sold (Liability)</td>
                            <td colspan="5">{{m.all.total_value_sold || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Total Number of Gift Cards Sold</td>
                            <td colspan="5">{{m.all.total_cards_sold || 0}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">Total Gift Card Sold In-Store</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_instore || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 32px;">GC Sold In-Store as Cash</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_instore_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 32px;">GC Sold In-Store as Credit</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_instore_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Total Gift Card Sold Online</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_online || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Donated Gift Card Value</td>
                            <td colspan="5">{{m.all.donated_gift_card_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Redeemed (Tender)</td>
                            <td colspan="5">{{m.all.total_gift_card_redeemed || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">Total Gift Cards Redeemed In-Store</td>
                            <td colspan="5">{{m.all.total_gift_card_redeemed_instore || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Total Gift Cards Redeemed Online</td>
                            <td colspan="5">{{m.all.total_gift_card_redeemed_online || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr class="border-top">
                            <td colspan="3">Outstanding Gift Card Liability</td>
                            <td colspan="5">{{m.all.outstanding_liability_total || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 4. PAYMENT TYPE SUMMARY -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Payment Type Summary</td>
                        </tr>
                        <tr class="border-bottom">
                            <td colspan="3"><b>Total Payments Collected</b></td>
                            <td colspan="5"><b>{{m.adjusted.adjTotalCollected || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Total Cash Collected</td>
                            <td colspan="5">{{m.adjusted.adjTotalCash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 32px;">In-Store Cash Collected</td>
                            <td colspan="5">{{m.adjusted.adjTotalPOSCash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Online Cash Collected</td>
                            <td colspan="5">{{m.online.cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 32px;">Kiosk Cash Collected</td>
                            <td colspan="5">{{m.kiosk.cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Total Credit/Debit Collected</td>
                            <td colspan="5">{{m.adjusted.adjTotalCard || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 32px;">In-Store Credit/Debit Collected</td>
                            <td colspan="5">{{m.adjusted.adjTotalPOSCard || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 32px;">Online Credit/Debit Collected</td>
                            <td colspan="5">{{m.online.card || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 32px;">Kiosk Credit/Debit Collected</td>
                            <td colspan="5">{{m.kiosk.card || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Credit Keyed</td>
                            <td colspan="5">{{m.all.credit_keyed || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Third-Party Payments</td>
                            <td colspan="5">{{m.all.third_party || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngFor="let tp of m.all.payment_type_raw_summary">
                            <td colspan="3" style="padding-left: 32px;">{{tp.payment_type_raw}} ({{tp.payment_count || 0}})</td>
                            <td colspan="5">{{tp.total_collected || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Invoice Credit Collected ({{m.all.invoice_credit_count || 0}})</td>
                            <td colspan="5">{{m.all.invoice_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 5. COLLECTION SUMMARY -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Collection Summary</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Net Sales Collected</td>
                            <td colspan="5">{{m.adjusted.adjNetSales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Taxes Collected</td>
                            <td colspan="5">{{m.adjusted.adjTaxes || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Tips Collected</td>
                            <td colspan="5">{{m.all.tips || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <!-- Auto gratuity (ENG-5810): already inside Tips; shown on its own for stores that charge it -->
                        <ng-container *ngIf="+m.all.auto_gratuity > 0">
                            <tr>
                                <td colspan="3" style="padding-left: 20px;">Incl. Auto Gratuity</td>
                                <td colspan="5">{{m.all.auto_gratuity || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="padding-left: 32px;">In-Store Auto Gratuity</td>
                                <td colspan="5">{{m.pos.auto_gratuity || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="padding-left: 32px;">Online Auto Gratuity</td>
                                <td colspan="5">{{m.online.auto_gratuity || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="3">Delivery Fees</td>
                            <td colspan="5">{{m.all.delivery_fees || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Platform Charges</td>
                            <td colspan="5">{{m.all.platform_charges || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Redeemed</td>
                            <td colspan="5">{{m.all.total_gift_card_redeemed || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Sold (Liability)</td>
                            <td colspan="5">{{m.all.total_value_sold || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr class="border-top border-bottom">
                            <td colspan="3"><b>Total Payments Collected</b></td>
                            <td colspan="5"><b>{{m.adjusted.adjTotalCollected || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                    </table>

                    <!-- 6. PERFORMANCE SUMMARY -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Performance Summary</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Guest Count</td>
                            <td colspan="5">{{m.all.total_receipts_count || m.all.total_orders || 0}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">In-Store Guest Count</td>
                            <td colspan="5">{{m.pos.total_receipts_count || m.pos.total_orders || 0}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Online Guest Count</td>
                            <td colspan="5">{{m.online.total_receipts_count || m.online.total_orders || 0}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Kiosk Guest Count</td>
                            <td colspan="5">{{m.kiosk.total_receipts_count || m.kiosk.total_orders || 0}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Third-party apps Guest Count</td>
                            <td colspan="5">{{m.third.total_receipts_count || m.third.total_orders || 0}}</td>
                        </tr>
                        <tr>
                            <td colspan="3"><b>Average Ticket Value</b></td>
                            <td colspan="5"><b>{{m.all.average_ticket_value || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3" style="padding-left: 20px;">Average Ticket Value In-Store</td>
                            <td colspan="5">{{m.pos.average_ticket_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;">Average Ticket Value Online</td>
                            <td colspan="5">{{m.online.average_ticket_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="store?.hasModule('KIOSK_MODULE')">
                            <td colspan="3" style="padding-left: 20px;">Average Ticket Value Kiosk</td>
                            <td colspan="5">{{m.kiosk.average_ticket_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="m.hasThirdParty">
                            <td colspan="3" style="padding-left: 20px;">Average Ticket Value Third-party apps</td>
                            <td colspan="5">{{m.third.average_ticket_value || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 7. CASH SUMMARY -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Cash Summary</td>
                        </tr>
                        <tr>
                            <td colspan="3"><b>Total CASH Collected</b></td>
                            <td colspan="5"><b>{{m.adjusted.adjTotalCash || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3">Total Split CASH Collected</td>
                            <td colspan="5">{{m.pos.split_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total CASH Taxable Net Sales</td>
                            <td colspan="5">{{m.all.cash_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total CASH Non-Taxable Net Sales</td>
                            <td colspan="5">{{m.all.cash_non_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total State Tax Collected on CASH</td>
                            <td colspan="5">{{m.all.state_tax_collected_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Local Tax Collected on CASH</td>
                            <td colspan="5">{{m.all.local_tax_collected_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Sold Cash</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_instore_cash || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">
                            <td colspan="3">Credit Tip Pay Out</td>
                            <td colspan="5">{{m.all.credit_tips || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">
                            <td colspan="3">Net Cash After Tips</td>
                            <td colspan="5">{{m.all.net_cash_after_tip || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 8. CREDIT SUMMARY -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">Credit Summary</td>
                        </tr>
                        <tr>
                            <td colspan="3"><b>Total CREDIT Collected</b></td>
                            <td colspan="5"><b>{{m.paymentSummaryCardTotal || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                        <tr *ngIf="store?.hasModule('POS')">
                            <td colspan="3">Total Split CREDIT Collected</td>
                            <td colspan="5">{{m.pos.split_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total CREDIT Taxable Net Sales</td>
                            <td colspan="5">{{m.all.credit_taxable_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total State Tax Collected on CREDIT</td>
                            <td colspan="5">{{m.all.state_tax_collected_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Local Tax Collected on CREDIT</td>
                            <td colspan="5">{{m.all.local_tax_collected_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Tip Collected on CREDIT</td>
                            <td colspan="5">{{m.all.credit_tips || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Sold CREDIT</td>
                            <td colspan="5">{{m.all.total_gift_card_sold_instore_credit || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Gift Cards Redeemed</td>
                            <td colspan="5">{{m.all.total_gift_card_redeemed || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                    </table>

                    <!-- 9. VARIANCE CHECK -->
                    <table cellpadding="5px" cellspacing="1" style="width: 100%; margin-top: 16px;">
                        <tr>
                            <td colspan="8" class="header">VARIANCE CHECK (SHOULD = $0.00)</td>
                        </tr>
                        <tr>
                            <td colspan="3">Total Tenders from Sales</td>
                            <td colspan="5">{{varianceCheck.total_tenders || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Total Net Sales</td>
                            <td colspan="5">{{varianceCheck.net_sales || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Total Sales Tax</td>
                            <td colspan="5">{{varianceCheck.taxes || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Additional Taxes</td>
                            <td colspan="5">{{varianceCheck.additional_taxes || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Total Tips</td>
                            <td colspan="5">{{varianceCheck.tips || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Gift Cards Sold</td>
                            <td colspan="5">{{varianceCheck.gift_cards_sold || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr>
                            <td colspan="3">Minus Total Refunds</td>
                            <td colspan="5">{{varianceCheck.refunds || 0 | safeCurrency:'USD'}}</td>
                        </tr>
                        <tr class="border-top border-bottom">
                            <td colspan="3"><b>Difference</b></td>
                            <td colspan="5"><b>{{varianceCheck.difference || 0 | safeCurrency:'USD'}}</b></td>
                        </tr>
                    </table>

                </div>

                <!-- ===== RIGHT COLUMN: DAILY TABLES (statement data) ===== -->
                <div fxFlex="75%" style="margin-right: 5px">
                    <div class="daily-report-header">
                        Daily Period Report
                    </div>
                    <div class="daily-summary-table">
                        <table cellpadding="5px" cellspacing="1" style="width: 100%;">
                            <tr class="border-bottom">
                                <td>Order Date</td>
                                <td>Order Count</td>
                                <td>Average Order Value</td>
                                <td>Total Gross Sales</td>
                                <td>Total Gross Sales POS</td>
                                <td>Total Gross Sales Online</td>
                                <td *ngIf="showThirdPartyColumns">Total Gross Sales Third-party apps</td>
                                <td>Total Non-Taxable Sales</td>
                                <td>Total Non-Taxable Sales Cash</td>
                                <td>Total Non-Taxable Sales Card</td>
                                <td>Total Discounts</td>
                                <td>Total Discounts POS</td>
                                <td>Total Discounts Online</td>
                                <td>Total Net Sales</td>
                                <td>Total Net Sales POS</td>
                                <td>Total Net Sales Online</td>
                                <td *ngIf="showThirdPartyColumns">Total Net Sales Third-party apps</td>
                                <td>Total Taxes</td>
                                <td>Total Taxes POS</td>
                                <td>Total Taxes Online</td>
                                <td>Total Tips</td>
                                <td>Total Tips POS</td>
                                <td>Total Tips Online</td>
                                <td>Total Delivery Fees</td>
                                <td>Total Delivery Fees POS</td>
                                <td>Total Delivery Fees Online</td>
                                <td>Total Platform Charges</td>
                                <td>Total Platform Charges POS</td>
                                <td>Total Platform Charges Online</td>
                                <td>Total Refund(Qty)</td>
                                <td>Total Refund($)</td>
                                <td class="border-right">Total Receipts</td>
                                <td class="border-right">Total Receipts POS</td>
                                <td class="border-right">Total Receipts Online</td>
                                <td class="border-right" *ngIf="showThirdPartyColumns">Total Receipts Third-party apps</td>
                            </tr>
                            <tr *ngFor="let record of data.records" class="align-right">
                                <td>{{ record.order_date}}</td>
                                <td>{{ record.order_count}}</td>
                                <td>{{ record.average_order_value || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.gross_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.gross_sales_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.gross_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td *ngIf="showThirdPartyColumns">{{ record.gross_sales_third_party || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.non_taxable_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.non_taxable_sales_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.discounts || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.discounts_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.discounts_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.net_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.net_sales_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.net_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td *ngIf="showThirdPartyColumns">{{ record.net_sales_third_party || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.taxes || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.taxes_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.taxes_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.tips || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.tips_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.tips_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.delivery_fees || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.delivery_fees_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.delivery_fees_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.platform_charges || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.platform_charges_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.platform_charges_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.refund_quantity || 0 }}</td>
                                <td>{{ record.refund_total || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right">{{ record.total_receipts || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right">{{ record.total_receipts_pos || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right">{{ record.total_receipts_online || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right" *ngIf="showThirdPartyColumns">{{ record.total_receipts_third_party || 0 | safeCurrency:'USD' }}</td>
                            </tr>
                            <tr class="align-right border-top">
                                <td>Total</td>
                                <td>{{ data.summary.total_order_count || 0 }}</td>
                                <td></td>
                                <td>{{ data.summary.total_gross_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_gross_sales_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_gross_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td *ngIf="showThirdPartyColumns">{{ data.summary.total_gross_sales_third_party || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sales_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_discounts || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_discounts_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_discounts_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_sales || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_sales_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_sales_online || 0 | safeCurrency:'USD' }}</td>
                                <td *ngIf="showThirdPartyColumns">{{ data.summary.total_net_sales_third_party || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_taxes || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_taxes_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_taxes_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_tips || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_tips_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_tips_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_delivery_fees || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_delivery_fees_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_delivery_fees_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_platform_charges || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_platform_charges_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_platform_charges_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_refund_quantity || 0 }}</td>
                                <td>{{ data.summary.total_refund_total || 0 | safeCurrency:'USD'}}</td>
                                <td class="border-right">{{ data.summary.total_total_receipts || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right">{{ data.summary.total_total_receipts_pos || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right">{{ data.summary.total_total_receipts_online || 0 | safeCurrency:'USD' }}</td>
                                <td class="border-right" *ngIf="showThirdPartyColumns">{{ data.summary.total_total_receipts_third_party || 0 | safeCurrency:'USD' }}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="daily-report-header" style="margin-top: 20px;">
                        Daily Payment Summary
                    </div>
                    <div class="daily-summary-table">
                        <table cellpadding="5px" cellspacing="1" style="width: 100%;">
                            <tr class="border-bottom">
                                <td>Order Date</td>
                                <td>Cash Count</td>
                                <td>Total Cash</td>
                                <td>Cash POS</td>
                                <td>Cash POS Refund</td>
                                <td>Cash Online</td>
                                <td>Cash Online Refund</td>
                                <td>Card Count</td>
                                <td>Total Card</td>
                                <td>Card POS</td>
                                <td>Card POS Refund</td>
                                <td>Card Online</td>
                                <td>Total Credit Keyed</td>
                                <td>Credit Keyed POS</td>
                                <td>Card Online Refund</td>
                                <td>Total Non-Taxable Sales Cash</td>
                                <td>Total Non-Taxable Sales Cash POS</td>
                                <td>Non-Taxable Sales Cash POS Refund</td>
                                <td>Total Non-Taxable Sales Cash Online</td>
                                <td>Non-Taxable Sales Cash Online Refund</td>
                                <td>Total Non-Taxable Sales Card</td>
                                <td>Total Non-Taxable Sales Card POS</td>
                                <td>Non-Taxable Sales Card POS Refund</td>
                                <td>Total Non-Taxable Sales Card Online</td>
                                <td>Total Refund(Qty)</td>
                                <td>Total Refund($)</td>
                                <td>Total Non-Taxable Sales Card Online Refund</td>
                                <td>Total Gifts </td>
                                <td>Total Gifts POS</td>
                                <td>Gifts POS Refund</td>
                                <td>Total Gifts Online</td>
                                <td>Gifts Online Refund</td>
                                <td>Total Others </td>
                                <td>Total Others POS</td>
                                <td>Others POS Refund</td>
                                <td>Total Others Online</td>
                                <td>Others Online Refund</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">Credit Tip Pay Out</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">End Cash Total</td>
                            </tr>
                            <tr *ngFor="let record of data.records" class="align-right">
                                <td>{{ record.order_date}}</td>
                                <td>{{ record.order_count_cash}}</td>
                                <td>{{ record.cash || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.cash_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_pos_cash_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.cash_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_online_cash_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.order_count_card}}</td>
                                <td>{{ record.card || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.card_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_pos_card_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.card_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.credit_keyed || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.credit_keyed_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_online_card_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_cash || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_cash_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_non_taxable_pos_cash_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_cash_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_non_taxable_online_cash_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_card || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_card_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_non_taxable_pos_card_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.non_taxable_sale_card_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.refund_quantity || 0 }}</td>
                                <td>{{ record.refund_total || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ record.net_non_taxable_online_card_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.gifts || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.gifts_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_pos_gift_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.gifts_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_online_gift_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.others || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.others_pos || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_pos_other_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.others_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ record.net_online_other_refund || 0 | safeCurrency:'USD'}}</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">{{ record.credit_tips || 0 | safeCurrency:'USD'}}</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">{{ record.net_cash_after_tip || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                            <tr class="align-right border-top">
                                <td style="text-align: start;">Total</td>
                                <td>{{ data.summary.total_order_count_cash || 0 }}</td>
                                <td>{{ data.summary.total_cash || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_cash_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_pos_cash_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_cash_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_online_cash_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_order_count_card || 0 }}</td>
                                <td>{{ data.summary.total_card || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_card_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_pos_card_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_card_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_credit_keyed || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_credit_keyed_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_online_card_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_cash || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_cash_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_non_taxable_pos_cash_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_cash_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_non_taxable_online_cash_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_card || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_card_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_non_taxable_pos_card_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_non_taxable_sale_card_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_refund_quantity || 0 }}</td>
                                <td>{{ data.summary.total_refund_total || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_non_taxable_online_card_refund || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ data.summary.total_gifts || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_gifts_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_pos_gift_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_gifts_online || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_online_gift_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_total_others || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_total_others_pos || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_net_pos_other_refund || 0 | safeCurrency:'USD' }}</td>
                                <td>{{ data.summary.total_total_others_online || 0 | safeCurrency:'USD'}}</td>
                                <td>{{ data.summary.total_net_online_other_refund || 0 | safeCurrency:'USD'}}</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">{{ data.summary.total_credit_tips || 0 | safeCurrency:'USD'}}</td>
                                <td *ngIf="data.store.feature_flag.reporting_subtract_credit_tips_from_cash">{{ data.summary.total_net_cash_after_tip || 0 | safeCurrency:'USD'}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
